/**
 * Organic Search Attribution Tracker
 * For: Runyon's Fine Furniture (Shopify)
 * By: Boosted Lab LLC
 *
 * PURPOSE:
 * Paid and Shopping traffic arrives with UTM parameters already in the URL.
 * Organic search traffic arrives with a clean URL and no UTMs.
 * This script detects organic search visits via document.referrer,
 * stores the source in a first-party cookie, and injects UTM params
 * into the page URL so the Jotform embed handler picks them up
 * and passes them into the form's hidden fields.
 *
 * INSTALL:
 * Add this script to your Shopify theme.liquid file, placed BEFORE
 * the Jotform embed script so it runs first.
 *
 * <script src="{{ 'runyons-organic-tracking.js' | asset_url }}"></script>
 *
 * Or paste the contents directly in a <script> tag before the Jotform embed.
 */

(function () {
  'use strict';

  // --- CONFIG ---
  var COOKIE_NAME = 'bl_traffic_source';
  var COOKIE_DAYS = 30; // How long to remember the source
  var CAMPAIGN = 'boosted_lab_seo';

  // Search engines to detect as organic
  var ORGANIC_ENGINES = {
    'google.com': 'google',
    'google.co': 'google',
    'bing.com': 'bing',
    'yahoo.com': 'yahoo',
    'duckduckgo.com': 'duckduckgo',
    'baidu.com': 'baidu',
    'yandex.com': 'yandex',
    'ecosia.org': 'ecosia'
  };

  // --- COOKIE HELPERS ---
  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  }

  // --- DETECTION LOGIC ---
  function getUrlParam(param) {
    var search = window.location.search;
    var match = search.match(new RegExp('[?&]' + param + '=([^&]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function hasExistingUtms() {
    return getUrlParam('utm_source') !== null || getUrlParam('utm_medium') !== null;
  }

  function detectOrganicEngine(referrer) {
    if (!referrer) return null;
    try {
      var hostname = new URL(referrer).hostname.toLowerCase();
      for (var domain in ORGANIC_ENGINES) {
        if (hostname.indexOf(domain) !== -1) {
          return ORGANIC_ENGINES[domain];
        }
      }
    } catch (e) {
      // Invalid referrer URL, ignore
    }
    return null;
  }

  // --- MAIN ---

  // Step 1: Determine traffic source on every entry from an external referrer.
  //         Always update the cookie when a new external source is detected,
  //         so returning visitors or new sessions get fresh attribution.
  //         Only skip detection on internal page-to-page navigation
  //         (referrer is the same site).

  var isInternalNav = false;
  try {
    if (document.referrer) {
      var refHost = new URL(document.referrer).hostname.toLowerCase();
      isInternalNav = refHost.indexOf('runyonsfinefurniture.com') !== -1;
    }
  } catch (e) {}

  if (!isInternalNav) {
    // This is either a fresh entry or an external referrer — re-evaluate source
    if (hasExistingUtms()) {
      // Paid, Shopping, email, etc. — already tracked, don't interfere
      setCookie(COOKIE_NAME, 'has_utms', COOKIE_DAYS);
    } else {
      var engine = detectOrganicEngine(document.referrer);
      if (engine) {
        // Organic search visit — store the source
        var sourceData = JSON.stringify({
          utm_source: engine,
          utm_medium: 'organic',
          utm_campaign: CAMPAIGN
        });
        setCookie(COOKIE_NAME, sourceData, COOKIE_DAYS);
      } else if (!getCookie(COOKIE_NAME)) {
        // Direct visit with no existing cookie — mark as direct
        setCookie(COOKIE_NAME, 'direct', COOKIE_DAYS);
      }
      // If direct visit but cookie already exists, leave it alone
      // (preserves original source from earlier in the session)
    }
  }

  // Step 2: If this is an organic visit, inject UTMs into the URL
  //         so the Jotform embed handler picks them up
  var cookie = getCookie(COOKIE_NAME);
  if (cookie && cookie !== 'has_utms' && cookie !== 'direct') {
    try {
      var data = JSON.parse(cookie);
      if (data.utm_source && !hasExistingUtms()) {
        var url = new URL(window.location.href);
        url.searchParams.set('utm_source', data.utm_source);
        url.searchParams.set('utm_medium', data.utm_medium);
        url.searchParams.set('utm_campaign', data.utm_campaign);
        window.history.replaceState(null, '', url.toString());
      }
    } catch (e) {
      // Cookie data corrupted, ignore
    }
  }
})();
